export default "__VITE_ASSET__IrVEZspY__"